import "remixicon/fonts/remixicon.css"
import React, {
  Dispatch,
  ReactNode,
  ReactElement,
  useState,
  useCallback,
  useEffect,
} from "react"
import * as styles from "./dialog.module.scss"

interface Props {
  open: boolean
  title: string
  confirmText?: string
  cancelText?: string
  onConfirm?: () => unknown | Promise<unknown>
  onCancel?: () => unknown | Promise<unknown>
  onClose?: Dispatch<void>
  danger?: boolean
  children: ReactNode
}

export const Dialog = React.memo((props: Props): ReactElement => {
  const {
    open,
    title,
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
    onClose,
    danger,
    children,
  } = props

  const [isOpened, setIsOpened] = useState(open)
  const handleClose = useCallback(() => {
    setIsOpened(false)
    onClose?.()
  }, [onClose])
  const handleConfirm = useCallback(async () => {
    await onConfirm?.()
    handleClose()
  }, [onConfirm, handleClose])
  const handleCancel = useCallback(async () => {
    await onCancel?.()
    handleClose()
  }, [onCancel, handleClose])

  useEffect(() => {
    setIsOpened(open)
  }, [open])

  return (
    <>
      {isOpened && (
        <div className={styles.overlay}>
          <div className={styles.content}>
            <button
              type="button"
              className={styles.closeButton}
              onClick={handleCancel}
            >
              <i className="ri-close-large-line"></i>
            </button>
            <h2>{title}</h2>
            <div className={styles.description}>{children}</div>

            <div className={styles.buttons}>
              {cancelText && (
                <button className={styles.normalButton} onClick={handleCancel}>
                  {cancelText}
                </button>
              )}
              {confirmText && (
                <button
                  className={danger ? styles.dangerButton : styles.normalButton}
                  onClick={handleConfirm}
                >
                  {confirmText}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
})
